// extracted by mini-css-extract-plugin
export default {"container":"HydrogenStorage_container__GC0wV","storageTable":"HydrogenStorage_storageTable__U+JQT","storageTank":"HydrogenStorage_storageTank__9mbho"};